import { JsonPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ErrorResponseDetail } from '@ddv/http';
import { ModalDirective, ModalOptions } from '@hs/ui-core-layout';
import { IconComponent } from '@hs/ui-core-presentation';

@Component({
    selector: 'ddv-initialization-errors',
    templateUrl: './initialization-errors.component.html',
    styleUrls: ['./initialization-errors.component.scss'],
    imports: [
        IconComponent,
        ModalDirective,
        JsonPipe,
    ],
})
export class InitializationErrorsComponent {
    @Input() errors: { message: string, error: ErrorResponseDetail }[] = [];

    protected detail: ErrorResponseDetail | undefined;
    protected modalOptions: ModalOptions = {
        position: 'bottom-left',
    };

    protected showDetail(event: MouseEvent, error: { message: string, error: ErrorResponseDetail }): void {
        this.modalOptions.anchorToElement = event.target as HTMLElement;
        this.detail = error.error;
    }
}
